module.exports = __webpack_public_path__ + "img/img_red.e6e9dfed.png";